<template>
  <v-container>
    <div class="form-npa private-pg">
      <div class="position">
        <div class="bg-white p-20">
          <form action="">
            <div class="form-head">
              <Widget position="menu_profile" />
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn
                          dark
                          v-on="on"
                          class="navbar-toggler-profile"
                  >
                    {{ $t("Профиль") }} <span class="caret"></span>
                  </v-btn>
                </template>
                <v-list class="navbar-collapse">
                  <v-list-item>
                    <Widget position="menu_profile" />
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
            <div class="form-body">
              <div class="profile-section" v-if="user && fields">
                <div class="profile-user-image">
                  <div class="user-image-aside">
                    <h2>{{ $t("Профиль") }}</h2>
                    <div class="img-circle">
                      <input
                        id="file"
                        ref="file"
                        type="file"
                        class="hide"
                        @change="handleFileUpload"
                      />
                      <template v-if="user.photo">
                        <img :src="baseUrl + user.fullFilesDirectory" alt="" />
                        <a @click="changeAvatar" class="add-image-profile changeAvatar">{{ $t("Изменить картинку") }}</a>
                      </template>
                      <template v-else>
<!--                        <img src="@/assets/user.jpg" alt="" />-->
                        <a class="add-image-profile" @click="changeAvatar">{{ $t("Добавить картинку") }}</a>
                      </template>
                    </div>
                    <div class="person-gender">
                      <label>
                        <input
                          type="radio"
                          @click="updateSex(1)"
                          name="sex"
                          :class="{ checked: user.sex && user.sex.id === 1 }"
                        />
                        <div>{{ $t('М') }}</div>
                      </label>
                      <label>
                        <input
                          type="radio"
                          @click="updateSex(2)"
                          name="sex"
                          :class="{ checked: user.sex && user.sex.id === 2 }"
                        />
                        <div>{{ $t('Ж') }}</div>
                      </label>
                    </div>
                    <div class="date-of-birth">
                      <h2>{{ $t("Дата рождения") }}:</h2>
                      <template>
                        <v-menu
                          ref="menu"
                          v-model="fields.birth_date.menu"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <a v-if="!user.birth_date" v-on="on">
                              {{ $t("добавить") }}
                            </a>
                            <a v-else v-on="on">
                              {{
                                new Date(user.birth_date) | dateFormat('DD.MM.YYYY')
                              }}
                            </a>
                          </template>
                          <v-date-picker
                            ref="picker"
                            v-if="fields"
                            v-model="fields.birth_date.value"
                            no-title
                            :max="new Date().toISOString().substr(0, 10)"
                            :weekday-format="getDay"
                            :month-format="getMonthFormat"
                            :header-date-format="getHeaderDateFormat"
                            min="1950-01-01"
                            @change="updateDate"
                          />
                        </v-menu>
                      </template>
                    </div>
                  </div>
                </div>
                <div class="profile-user-info">
                  <ul>
                    <li>
                      <span>{{ $t("Логин") }}:</span>
                      <a
                        v-if="
                          (user.nick_name == null || user.nick_name == '') &&
                            !fields.nickName.showEdit
                        "
                        @click="fields.nickName.showEdit = true"
                      >
                        {{ $t("добавить") }}
                      </a>
                      <a
                        v-else-if="!fields.nickName.showEdit"
                        @click="fields.nickName.showEdit = true"
                      >
                        {{ user.nick_name }}
                      </a>
                      <InlineEdit
                        v-else
                        :params="fields.nickName"
                        @update-field="updateField($event)"
                      />
                    </li>
                    <li>
                      <span>{{ $t("Электронный адрес") }}:</span>
                      {{ user.email }}
                    </li>
                    <li>
                      <span>{{ $t("ФИО") }}:</span>
                      <a
                        v-if="
                          (user.first_name == null || user.first_name == '') &&
                            (user.second_name == null || user.second_name == '') &&
                            (user.last_name == null || user.last_name == '') &&
                            !fields.name.showEdit
                        "
                        @click="fields.name.showEdit = true"
                      >
                        {{ $t("добавить") }}
                      </a>
                      <a
                        v-else-if="!fields.name.showEdit"
                        @click="fields.name.showEdit = true"
                      >
                        {{ user.second_name }} {{ user.first_name }}
                        {{ user.last_name }}
                      </a>
                      <InlineEdit
                        v-else
                        :params="fields.name"
                        @update-field="updateField($event)"
                      />
                    </li>
                    <li>
                      <span>{{ $t("Телефон") }}:</span>
                      <a
                        v-if="
                          (user.phone == null || user.phone == '') &&
                            !fields.phone.showEdit
                        "
                        @click="fields.phone.showEdit = true"
                      >
                        {{ $t("добавить") }}
                      </a>
                      <a
                        v-else-if="!fields.phone.showEdit"
                        @click="fields.phone.showEdit = true"
                      >
                        {{ user.phone }}
                      </a>
                      <InlineEdit
                        v-else
                        :params="fields.phone"
                        @update-field="updateField($event)"
                      />
                    </li>
                    <li>
                      <span>{{ $t("Адрес") }}:</span>
                      <a
                        v-if="
                          (user.address == null || user.address == '') &&
                            !fields.address.showEdit
                        "
                        @click="fields.address.showEdit = true"
                      >
                        {{ $t("добавить") }}
                      </a>
                      <a
                        v-else-if="!fields.address.showEdit"
                        @click="fields.address.showEdit = true"
                      >
                        {{ user.address }}
                      </a>
                      <InlineEdit
                        v-else
                        :params="fields.address"
                        @update-field="updateField($event)"
                      />
                    </li>
                    <li v-if="user.systemRoleFlag">
                      <span>{{ $t("Организация") }}:</span>
                      <a
                        v-if="user.developer == null && !fields.developer.showEdit"
                        @click="fields.developer.showEdit = true"
                      >
                        {{ $t("добавить") }}
                      </a>
                      <a
                        v-else-if="!fields.developer.showEdit"
                        @click="fields.developer.showEdit = true"
                      >
                        <v-icon
                          v-if="user.developer.status === false"
                          class="nv_icon mr-1"
                          x-small
                        />
                        {{ user.developer.transName }}
                      </a>
                      <InlineEdit
                        v-else
                        :params="fields.developer"
                        @update-field="updateField($event)"
                      />
                    </li>
                    <li v-if="user.systemRoleFlag">
                      <span>{{ $t("Отдел/департамент") }}:</span>
                      <a
                        v-if="
                          (user.department == null || user.department == '') &&
                            !fields.department.showEdit
                        "
                        @click="fields.department.showEdit = true"
                      >
                        {{ $t("добавить") }}
                      </a>
                      <a
                        v-else-if="!fields.department.showEdit"
                        @click="fields.department.showEdit = true"
                      >
                        {{ user.department }}
                      </a>
                      <InlineEdit
                        v-else
                        :params="fields.department"
                        @update-field="updateField($event)"
                      />
                    </li>
                    <li>
                      <span>{{ $t("Должность") }}:</span>
                      <a
                        v-if="user.post == null && !fields.post.showEdit"
                        @click="fields.post.showEdit = true"
                      >
                        {{ $t("добавить") }}
                      </a>
                      <a
                        v-else-if="!fields.post.showEdit"
                        @click="fields.post.showEdit = true"
                      >
                        {{ user.post.transName }}
                      </a>
                      <InlineEdit
                        v-else
                        :params="fields.post"
                        @update-field="updateField($event)"
                      />
                    </li>
                    <li>
                      <span>{{ $t("Гражданство") }}:</span>
                      <a
                        v-if="
                          user.citizenship == null && !fields.citizenship.showEdit
                        "
                        @click="fields.citizenship.showEdit = true"
                      >
                        {{ $t("добавить") }}
                      </a>
                      <a
                        v-else-if="!fields.citizenship.showEdit"
                        @click="fields.citizenship.showEdit = true"
                      >
                        {{ user.citizenship.transName }}
                      </a>
                      <InlineEdit
                        v-else
                        :params="fields.citizenship"
                        @update-field="updateField($event)"
                      />
                    </li>
                    <li>
                      <span>{{ $t("Пароль") }}:</span>
                      <a
                        v-if="!fields.password.showEdit"
                        @click="fields.password.showEdit = true"
                      >
                        {{ $t("изменить") }}
                      </a>
                      <InlineEdit
                        v-else
                        :params="fields.password"
                        @update-field="updateField($event)"
                      />
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import Widget from '@/components/app/Widget'
import InlineEdit from '@/components/user/InlineEdit'
import User from '@/model/user'
import moment from 'moment'
import mixin from '@/plugins/mixin/mixin'

export default {
  mixins: [mixin],
  components: {
    Widget,
    InlineEdit
  },
  data: () => ({
    user: [],
    image: '',
    fields: null,
    file: '',
    baseUrl: process.env.VUE_APP_BACK_URL
  }),
  created() {
    // загружаем данные, когда представление создано
    // и данные реактивно отслеживаются
    this.fetchData()
    this.scrollToTop()
  },
  methods: {
    fetchData() {
      User.getCurrentInfo().then((response) => {
        this.user = response.data
        this.initFields()
      })
    },
    initFields() {
      this.fields = {
        name: {
          name: 'name',
          showEdit: false,
          fields: [
            {
              name: 'secondName',
              label: 'Фамилия',
              value: this.user.second_name,
              type: 'varchar'
            },
            {
              name: 'firstName',
              label: 'Имя',
              value: this.user.first_name,
              type: 'varchar'
            },
            {
              name: 'lastName',
              label: 'Отчество',
              value: this.user.last_name,
              type: 'varchar'
            }
          ]
        },
        nickName: {
          name: 'nickName',
          showEdit: false,
          fields: [
            {
              name: 'nickName',
              label: 'Логин',
              value: this.user.nick_name,
              type: 'varchar'
            }
          ]
        },
        phone: {
          name: 'phone',
          showEdit: false,
          fields: [
            {
              name: 'phone',
              label: 'Телефон',
              value: this.user.phone,
              type: 'varchar'
            }
          ]
        },
        department: {
          name: 'department',
          showEdit: false,
          model: 'department',
          fields: [
            {
              name: 'department',
              label: 'Отдел/департамент',
              value: this.user.department,
              type: 'varchar'
            }
          ]
        },
        developer: {
          name: 'developer',
          showEdit: false,
          model: 'developer',
          fields: [
            {
              name: 'developer',
              label: 'Организация',
              value: this.user.developer,
              type: 'references'
            }
          ]
        },
        post: {
          name: 'post',
          showEdit: false,
          model: 'post',
          fields: [
            {
              name: 'post',
              label: 'citizenship',
              value: this.user.phone,
              type: 'references'
            }
          ]
        },
        citizenship: {
          name: 'citizenship',
          showEdit: false,
          model: 'citizenship',
          fields: [
            {
              name: 'citizenship',
              label: 'citizenship',
              value: this.user.phone,
              type: 'references'
            }
          ]
        },
        birth_date: {
          menu: false,
          value: this.user.birth_date
            ? moment(this.user.birth_date).format('YYYY-MM-DD')
            : ''
        },
        password: {
          name: 'password',
          showEdit: false,
          fields: [
            {
              name: 'password',
              type: 'password'
            }
          ]
        },
        address: {
          name: 'address',
          showEdit: false,
          model: 'address',
          fields: [
            {
              name: 'address',
              label: 'Адрес',
              value: this.user.address,
              type: 'varchar'
            }
          ]
        }
      }
    },
    updateField(result) {
      if (result.status) {
        if (result.user) {
          this.user = result.user
        }

        this.fields[result.fieldName].showEdit = false
      }
    },
    updateDate(date) {
      this.user.birth_date = date
      this.$refs.menu.save(date)
      User.update({ birthDate: date }).then((response) => {
        this.user = response.data
      })
    },
    updateSex(sex) {
      this.user.sex = {
        id: sex
      }

      User.update({ sex: sex }).then((response) => {
        this.user = response.data
      })
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0]
      let formData = new FormData()

      formData.append('file', this.file)

      User.updateAvatar(formData).then((response) => {
        this.user = response.data
      })
    },
    changeAvatar() {
      this.$refs.file.click()
    },
    scrollToTop() {
      window.scrollTo(0, 0)
    }
  }
}
</script>
